import React from 'react';

const SelectButtonRenderer = (props) => {
  const handleClick = () => {
    const { node, api } = props;
    const isSelected = node.isSelected();
    node.setSelected(!isSelected);
    api.refreshCells({ force: true });
  };

  return (
    <button onClick={handleClick}>
      {props.node.isSelected() ? 'Deselect' : 'Select'}
    </button>
  );
};

export default SelectButtonRenderer;
